import React from "react";
import FormLabel from "./styled/FormLabel";
import DocumentCard from "./styled/DocumentCard";
import DocumentUploader from "./styled/DocumentUploader";
import FormLabelDescription from "./styled/FormLabelDescription";
import StrongLabel from "./styled/StrongLabel";

const DocumentForm = ({
  documents,
  handleDocumentDelete,
  handleFileChange,
  loading,
}) => {
  return (
    <>
      <FormLabel>Adjuntar Cédula</FormLabel>
      <FormLabelDescription>
        Debe adjuntar <StrongLabel>por separado</StrongLabel> la parte {""}
        <StrongLabel>delantera</StrongLabel> y{" "}
        <StrongLabel>trasera</StrongLabel> de su cédula de identidad.
      </FormLabelDescription>
      {documents.map((document, index) => (
        <DocumentCard
          key={index}
          imageUrl={URL.createObjectURL(document)}
          onDelete={() => handleDocumentDelete(index, "cedula")}
        />
      ))}
      {documents.length < 2 && (
        <DocumentUploader
          onFileChange={(file) => handleFileChange(file, "cedula")}
          loading={loading}
          type="cedula"
        />
      )}
    </>
  );
};

export default DocumentForm;
